(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner-image"] && !Shopify.designMode) return;
  try {
    
  // This script is self-contained and will only affect this specific section type.
  // It ensures compatibility with the theme editor and other sections.
  
  if (!customElements.get('image-banner-slider')) {
    customElements.define('image-banner-slider', class ImageBannerSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.swiper-hero-banners-image');
        this.initSlider();
      }

      initSlider() {
        // Assuming Swiper.js is loaded globally by your theme
        if (typeof Swiper === 'undefined') {
          console.error('Swiper JS not loaded');
          return;
        }

        const swiper = new Swiper(this.slider, {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          // Add other Swiper options here if needed, e.g., pagination, navigation
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true,
          // },
        });
      }
    });
  }

  // Wrap the section in the custom element
  const sectionContainer = document.getElementById('shopify-section-{{ section.id }}');
  const sliderWrapper = document.createElement('image-banner-slider');
  sectionContainer.replaceChildren(...sectionContainer.childNodes, sliderWrapper);
  sliderWrapper.append(...Array.from(sectionContainer.childNodes).filter(node => node !== sliderWrapper));

  } catch(e) { console.error(e); }
})();
})();
